
export { default as FileCsvIcon } from "./FileCsv.js"
export { default as FileExcelIcon } from "./FileExcel.js"
export { default as FileIcon } from "./File.js"
export { default as FileImageIcon } from "./FileImage.js"
export { default as FilePdfIcon } from "./FilePdf.js"
export { default as FileTextIcon } from "./FileText.js"
export { default as FileWordIcon } from "./FileWord.js"
export { default as FileXMarkIcon } from "./FileXMark.js"